import React from 'react';
import MALogo from './LoginForm/MALogo';

const HelpPage = () => (
  <div className="container">
    <MALogo showClose={true} />

    <div className="margin-top">
      <h2>Looking to buy more credentials or need help?</h2>
      <p>Contact Danelle Kingham</p>
      <h3><a href="tel:+7146512990">(714) 651-2990</a></h3>
      <h3><a href="mailto:registration@motoamerica.com">registration@motoamerica.com</a></h3>
    </div>
  </div>
);

export default HelpPage;



// WEBPACK FOOTER //
// ./src/components/HelpPage.js